import script from "./MyInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./MyInvite.vue?vue&type=script&setup=true&lang=js"

import "./MyInvite.vue?vue&type=style&index=0&id=1e588066&lang=less&scoped=true"

import exportComponent from "D:\\aj项目\\code\\标准版观众登记中文\\visitor-regist_-standard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e588066"]])

export default __exports__